exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "html {\n  font-size: calc(100vw / 20);\n}\n@media screen and (min-width: 420px) {\n  html {\n    font-size: 18.75px;\n    width: 420px;\n    margin: auto;\n  }\n}\nbody {\n  margin: 0;\n  padding: 0;\n  font-family: sans-serif;\n}\n\ninput:disabled {\n  /* border: 1px solid #ddd; */\n  background-color: #fafafa;\n  color: black;\n  font-size: 14px;\n}\n\n/* .max-width {\n  max-width: 700px;\n  margin: auto;\n} */\n\np {\n  margin: 0;\n}\n\n.flex___3SFQ8 {\n  display: -ms-flexbox;\n  display: flex;\n}\n\n.am-search___i4ZFn {\n  width: 330px;\n}\n\n.html5-player-cover-view___2fnBb{\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  -ms-flex-pack: center;\n      justify-content: center;\n}\n\n.html5-player-middle-button___1QdlG{\n  cursor:unset;\n  position:unset;\n  top:unset;\n  left:unset;\n  margin-left:unset;\n  margin-top:unset;\n}", ""]);

// exports
exports.locals = {
	"flex": "flex___3SFQ8",
	"am-search": "am-search___i4ZFn",
	"html5-player-cover-view": "html5-player-cover-view___2fnBb",
	"html5-player-middle-button": "html5-player-middle-button___1QdlG"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"importLoaders":1,"localIdentName":"[local]___[hash:base64:5]"}!./node_modules/postcss-loader/lib?{"ident":"postcss"}!./src/index.css
// module id = 817
// module chunks = 2